import { useHistory } from "react-router-dom";
import FullWidthLayout from "../Common/FullwidthLayout";

export default function VerifyAccount() {
  const history = useHistory();

  return (
    <FullWidthLayout>
      <div className="lg-verify-account">
        <h2>Great, your account is verified!</h2>
        <p>Let's start building your council profile</p>
        <button
          className="primary-button"
          onClick={() => history.push(`/build-profile`)}
        >
          Create Council profile manually
        </button>
      </div>
    </FullWidthLayout>
  );
}
